module.exports = __webpack_public_path__ + "img/home-12-2.6a6481f8.png";